import {useState} from "react";
import {AutoComplete} from "antd";

export const BulkSelectWidget = ({bulkProducts, searchVal, setSearchVal, onSelect, disabled, props}) => {
    const [options, setOptions] = useState([]);

    const onChange = (data) => {
        setSearchVal(data);
    }

    const onSearch = (text) => {
        const newOptions = bulkProducts.filter(product => {
            const ltext = text.toLowerCase();
            return product.name.toLowerCase().includes(ltext);
        }).map(val => {
            return {
                key: val.id,
                value: `${val.name}`,
                product: val
            }
        });
        setOptions(newOptions)
    }

    const selectProduct = (val, option) => {
        if (onSelect) {
            onSelect(option.product);
        }
    }

    const autoCompleteStyle = {
        width: 200
    }
    return <AutoComplete style={autoCompleteStyle} value={searchVal} onChange={onChange}
        onSearch={onSearch} onSelect={selectProduct} disabled={disabled} options={options} placeholder={'Bulk Product'}/>
}